<div class="component-container">
  <div class="card text-center row has-float-btn">
    <ng-content></ng-content>
    <ng-content select="[text]"></ng-content>
    <div class="w-stretch pt-10">
      <div class="row-inline grid-sm">
        <div class="cell">
          @if (title) {
            <div class="row1">
              <div class="row-inline grid-sm">
                <div class="cell iconbox"><img [src]="iconUrl" [width]="iconWidth" alt=""></div>
                <div class="cell fz-16">{{title}}</div>
              </div>
            </div>
          }
          <div class="row2">
            <div class="text-large mt-2">{{value}}
              <span hidden class="fz-5 normal">
                <span class="offset-dy">|</span>
                Total
              </span>
            </div>
          </div>
        </div>
        <div class="cell">
          <ng-content select=".graph"></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>